// The staff page: a band of photos; the person in the middle gets their links under the photo. Ported from the
// approved concept (concept/src/09-pages.js and 07-slider.js).
import { $, $$, decode, onPageIn } from 'fx';
import { createSlider, renderLinks, srList } from 'slider';

// The staff photos' studio backdrop (#0e0e0e): a coach's cut-out is drawn on it, so it sits on the same black as
// everyone else's photo (it was the page's stage grey, #151515; the owner, 11 Oct 2026).
const BACKDROP = [14 / 255, 14 / 255, 14 / 255];

const view = $('[data-staff]');
if (view) init(view);

function init(view) {
  const D = JSON.parse($('#staff-data', view).textContent);
  const T = D.strings;
  const people = D.people;
  const box = $('#staff-socials', view);
  let shownFor = -1;

  // Staff photos fill their frame; coaches are cut-outs, shown in black and white with room above the head.
  const staff = createSlider({
    el: $('#staff-slider', view),
    strip: $('#staff-strip', view),
    live: $('#staff-live', view),
    scope: view,
    keys: true,
    labels: { drag: T.drag, position: T.position },
    data: people.map((p) => (p.cutout
      ? { img: p.img, name: p.name, meta: p.meta, opaque: true, bg: BACKDROP, mono: true, person: true, zoom: 1.4, oy: -0.056 }
      : { img: p.img, name: p.name, meta: p.meta, opaque: true, person: true, zoom: 1.04 })),
    onMove: () => box.classList.remove('on'),
    onSettle: (i) => showLinks(i),
    onEnterKey: () => { const a = $('#staff-social-list a', view); if (a) a.focus(); }
  });

  function showLinks(i) {
    const p = people[i];
    if (!p) return;
    const links = p.links || [];
    if (shownFor !== i) {
      shownFor = i;
      box.setAttribute('aria-label', T.links.replace('[name]', p.name));
      renderLinks($('#staff-social-list', view), links);
    }
    box.classList.toggle('on', links.length > 0);
  }

  srList($('#sr-staff', view), people.map((p) => `${p.name}, ${p.meta}`), (i) => staff.goTo(i));

  onPageIn(() => {
    $$('.view-top .crumb', view).forEach((c, k) => decode(c, { delay: 200 + k * 90, step: 18 }));
    shownFor = -1;
    staff.enter();
  });
}
